import * as React from "react";
import { Position } from "../../data/cv-data";
import { useTranslate } from "../../locales/hooks";

interface IAppProps {
  position: Position;
  showResponsibilities?: boolean;
  showAchievements?: boolean;
  showProjects?: boolean;
}

const CVPositionDescription: React.FunctionComponent<IAppProps> = ({
  position,
  showResponsibilities,
  showAchievements,
  showProjects,
}) => {
    const t = useTranslate();
  return (
    <div className="flex min-w-0 flex-1 flex-col gap-[10px] pb-[40px] md:max-w-[350px]">
      <div className="flex flex-col">
        <p className="font-['Bitter',sans-serif] text-[20px] font-bold text-[#0f172a]">
          {position.title}
        </p>
      </div>

      {/* Position Description */}
      {(position.responsibilities.length > 0 ||
        position.achievements.length > 0) && (
        <div className="font-['Inter',sans-serif] text-[12px] font-medium tracking-[-0.132px] text-[#334155] break-words">
          {showResponsibilities && position.responsibilities.length > 0 && (
            <>
              <p className="mb-0 leading-[1.5]">{t('positionBlock__responsibilitiesLabel')}</p>
              <ul className="list-disc">
                {position.responsibilities.map((responsibility, index) => (
                  <li key={index} className="mb-0 ms-[18px]">
                    <span className="leading-[1.5]">{responsibility}</span>
                  </li>
                ))}
              </ul>
              <br />
            </>
          )}

          {showAchievements && position.achievements.length > 0 && (
            <>
              <p className="mb-0 leading-[1.5]">{t('positionBlock__achievementsLabel')}</p>
              <ul className="list-disc">
                {position.achievements.map((achievement, index) => (
                  <li key={index} className="mb-0 ms-[18px]">
                    <span className="leading-[1.5]">{achievement}</span>
                  </li>
                ))}
              </ul>
            </>
          )}
        </div>
      )}

      {/* Projects Section */}
      {showProjects && position.projects.length > 0 && (
        <div className="flex flex-col gap-[12px] md:gap-[16px] mt-[8px] md:mt-[10px]">
          <p className="font-['Inter',sans-serif] font-bold text-[12px] md:text-[13px] text-[#0f172a] tracking-[-0.132px] leading-[1.5]">
            {t('positionBlock__projectsLabel')}
          </p>
          {position.projects.map((project, projectIndex) => (
            <div
              key={projectIndex}
              className="flex flex-col gap-[6px] md:gap-[8px] bg-[#f8fafc] p-[12px] md:p-[16px] rounded-[8px] border border-[#e2e8f0]"
            >
              {project.title && (
                <p className="font-['Inter',sans-serif] font-semibold text-[11px] md:text-[12px] text-[#0f172a] tracking-[-0.132px] leading-[1.4]">
                  {project.title}
                </p>
              )}
              <p className="font-['Inter',sans-serif] font-normal text-[10px] md:text-[11px] text-[#475569] tracking-[-0.11px] leading-[1.5]">
                {project.description}
              </p>
              {project.techStack.length > 0 && (
                <div className="flex flex-wrap gap-[6px] mt-[4px]">
                  {project.techStack.map((tech, techIndex) => (
                    <span
                      key={techIndex}
                      className="font-['Inter',sans-serif] font-medium text-[9px] md:text-[10px] text-[#64748b] bg-white px-[8px] py-[3px] rounded-[4px] border border-[#cbd5e1]"
                    >
                      {tech}
                    </span>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CVPositionDescription;
